import {
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
  TextField,
} from '@material-ui/core';
import axios from 'axios';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

const useStyle = makeStyles(({spacing}) => ({
  root: {
    marginTop: spacing(2),
    marginBottom: spacing(4),
    padding: '32px 16px',
  },
}));

const AdminAddClassroomForm = () => {
  const classes = useStyle();
  const [formData, setFormData] = useState({
    name: '',
  });

  let history = useHistory();

  const updateFormData = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const addClassroom = async (event) => {
    event.preventDefault();
    try {
      await axios.post('/api/classroom', formData);

      history.go(0).push('/admin/classrooms');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container
      component={Paper}
      elevation={0}
      maxWidth="sm"
      className={classes.root}
    >
      <form onSubmit={addClassroom}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Name"
              id="name"
              name="name"
              value={formData.name}
              onChange={updateFormData}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              value="formData"
            >
              Create Classroom
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default AdminAddClassroomForm;
